import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { SparklesIcon } from '@heroicons/react/24/outline';

export default function SetupPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setError('Invalid setup link — no token found.');
      return;
    }

    try {
      // Decode the JWT payload (middle segment, base64url)
      const parts = token.split('.');
      if (parts.length !== 3) throw new Error('Malformed token');
      const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));

      const userData = {
        id: payload.user_id,
        email: payload.sub,
        first_name: payload.first_name || '',
        last_name: payload.last_name || '',
        user_type: payload.user_type || 'client',
        must_reset_password: true,
      };

      localStorage.setItem('authToken', token);
      localStorage.setItem('userType', 'client');
      localStorage.setItem('userData', JSON.stringify(userData));

      navigate('/fill-profile', { replace: true });
    } catch {
      setError('This setup link is invalid or has expired. Please contact your coach.');
    }
  }, [searchParams, navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-dark-canvas flex items-center justify-center px-6">
        <div className="bg-dark-card rounded-2xl shadow-2xl p-10 max-w-md w-full text-center">
          <div className="w-12 h-12 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-red-400 text-xl">!</span>
          </div>
          <h2 className="text-xl font-bold text-white mb-2">Setup Link Error</h2>
          <p className="text-dark-muted text-sm">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-dark-canvas flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 bg-gradient-to-br from-fuchsia-400 to-violet-500 rounded-xl flex items-center justify-center shadow-lg animate-pulse">
          <SparklesIcon className="w-6 h-6 text-white" />
        </div>
        <p className="text-gray-400 text-sm">Setting up your account…</p>
      </div>
    </div>
  );
}
